import { render, staticRenderFns } from "./MonetizationEdit.vue?vue&type=template&id=2ed96407&scoped=true"
import script from "./MonetizationEdit.vue?vue&type=script&lang=js"
export * from "./MonetizationEdit.vue?vue&type=script&lang=js"
import style0 from "./MonetizationEdit.vue?vue&type=style&index=0&id=2ed96407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed96407",
  null
  
)

export default component.exports